import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { PageTitle } from '../../../../_metronic/layout/core'
import clsx from 'clsx'
import './Dashboard.css';
import Afluencia from './Afluencia';
import IndicadoresPrinciaples from './IndicadoresPrinciaples';
import DiarioComparativoVentas from '../Reportes/DiarioComparativoVentas';


export default function Dashboard({ title }) {

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.DASHBOARD_MALL]} >
                <PageTitle>{title}</PageTitle>

                { /* * * Optimal Table*/}
                <div className="card-body py-3">
                    <div className='d-flex align-items-center mb-1'><h3 className="fw-bolder mb-6 me-3">Afluencia Diaria</h3>
                    </div>
                    {
                        //AFLUENCIA
                        <Afluencia></Afluencia>
                    }
                </div>

                <div className="mb-5 mb-xl-8">
                    <div className="card-body py-3">
                    <div className='d-flex align-items-center mb-1'><h3 className="fw-bolder mb-6 me-3">Indicadores Principales</h3>
              </div>

                        <IndicadoresPrinciaples></IndicadoresPrinciaples>
                    </div>

                </div>
                {
                    //DIARIO COMPARATIVO VENTAS
                    <DiarioComparativoVentas title='Dashboard'></DiarioComparativoVentas>
                }

            </PermissionsGate>
        </>
    )
}